import React from 'react';
import { motion } from 'framer-motion';
const painPoints = ['Querés generar ingresos pero no sabés qué vender', 'Cocinás rico pero no sabés cómo convertir eso en dinero', 'No sabés cuánto cobrar y terminás ganando poco', 'Te da miedo invertir y no recuperar', 'Sentís que todo está saturado', 'No tenés un sistema, solo improvisás'];
export function PainPoints() {
  return <section className="py-20 md:py-28 bg-brown-dark text-beige relative overflow-hidden" data-id="element-175">
      {/* Decorative background elements */}
      <div className="absolute top-0 right-0 w-1/2 h-full bg-[#2F3D28] opacity-40 pointer-events-none" data-id="element-176"></div>
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden opacity-5 pointer-events-none" data-id="element-177">
        <svg viewBox="0 0 100 100" preserveAspectRatio="none" className="absolute w-full h-full" data-id="element-178">
          <path d="M0 100 C 20 0 50 0 100 100 Z" fill="currentColor" data-id="element-179" />
        </svg>
      </div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-180">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-181">
          <h2 className="text-3xl md:text-5xl font-bold mb-6" data-id="element-182">
            <span className="text-gold" data-id="element-183">Si hoy estás así…</span>{' '}
            <span className="text-olive-light" data-id="element-184">esto es para vos</span>
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-6" data-id="element-185">
          {painPoints.map((point, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="flex items-start gap-4 p-4 rounded-xl hover:bg-white/5 transition-colors" data-id="element-186">
              <div className="flex-shrink-0 mt-1" data-id="element-187">
                <svg className="w-6 h-6 text-red-400/80" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-188">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" data-id="element-189"></path>
                </svg>
              </div>
              <p className="text-lg font-medium text-beige/90" data-id="element-190">{point}</p>
            </motion.div>)}
        </div>
      </div>

      {/* Decorative SVG Divider Bottom */}
      <div className="absolute bottom-0 left-0 w-full overflow-hidden leading-none" data-id="element-191">
        <svg className="relative block w-full h-[40px]" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120" preserveAspectRatio="none" data-id="element-192">
          <path d="M1200 120L0 16.48 0 0 1200 0 1200 120z" fill="#F5F0EB" data-id="element-193"></path>
        </svg>
      </div>
    </section>;
}